import '@sage/design-tokens/css/base.css';
import 'carbon-react/lib/style/fonts.css';

export * from './components';
import TailwindPreset from './preset';
export const Preset = TailwindPreset;
